import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { CalendarAddIcon } from '@calendly/ui/components/icons';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
const ghostButtonCss = "g1oj534r";
const GhostButton = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(ghostButtonCss, props.className)} />);
export const CreateEventButton = ({
  onClick,
  isButtonExperimentEnabled
}) => isButtonExperimentEnabled ? <MinimalButton onClick={onClick}>
    <CalendarAddIcon spacingRight={4} />
    <p>
      {I18n.t('publisher.contacts.buttons.book_meeting')}
    </p>
  </MinimalButton> : <GhostButton decoration="ghost" onClick={onClick}>
    <CalendarAddIcon />
    <p>
      {I18n.t('publisher.contacts.buttons.create_event')}
    </p>
  </GhostButton>;

require("./create_event_button.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./create_event_button.js");